import { Component, ElementRef, ViewChild } from '@angular/core'
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ApifirstService } from './service/apifirst.service';
import jwt_decode from 'jwt-decode';
import { FdrsClientService } from './service/fdrs-client.service';
import { TranslateService } from '@ngx-translate/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import * as locales from 'ngx-bootstrap/locale';
import { data } from 'jquery';
// import { version } from 'process';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { TokenExpiryService } from './service/token-expiry.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [NgbModalConfig, NgbModal]

})
export class AppComponent {
  title = 'SBDTest';
  isLink = false;
  showDiagImage = false;
  CanShowFDRSIcon: boolean = false;
  @ViewChild('FDRSVersionPopup') FDRSVersionPopup: ElementRef | undefined;
  @ViewChild('VehicleModelMissing') VehicleModelMissing: ElementRef | undefined;
  @ViewChild('FDRSConnectionErrorPopup') FDRSConnectionErrorPopup: ElementRef | undefined;
  showExpiryNotification: boolean = false;
  showUnauthorizedAccessPage: boolean = false;
  constructor(private service: ApifirstService, private activateRoute: ActivatedRoute, private router: Router, private fdrsClientService: FdrsClientService, public translate: TranslateService, private localeService: BsLocaleService, private modalService: NgbModal, config: NgbModalConfig, private spinnerService: NgxSpinnerService, private notificationService: TokenExpiryService) {
    config.backdrop = 'static';
    config.keyboard = false;
    config.centered = true;
    this.translate.setDefaultLang('en');
    //this.defineLocales();
  }
  SBDTab = false
  SBDAccessGranted = false
  email = "";
  vin = "";
  companyname = ""
  marketcountry = "";
  lastname = "";
  firstname = "";
  // iframeurl="http://localhost:4200/?fdspToken=eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJQVFMiLCJhdWQiOiJQVFMiLCJmZHJzVmVyc2lvbiI6IjI0LjUuNiIsImNvdW50cnlDb2RlIjoiR0JSIiwiZGVhbGVyY29kZSI6IkdCUjRGb3JkIiwiaXNzIjoiRkRTUCIsInVzZXJUeXBlIjoiRk9SRF9JTlRFUk5BTCIsImV4cCI6MTYyMjIyMzY1NCwibGFuZ3VhZ2VDb2RlIjoiRU4iLCJpYXQiOjE2MjIxODA0NTQsImp0aSI6InBtYWhlbmQ5In0.rXnENX4Pr9MNMueUNMiHNJPO_npmf4jq744YLSTJ42E&Email=TTHUKRAL&Market=GB&CompanyName=ford&Vin=WF0RXXWPGRHU38253&FirstName=pranathy&LastName=mahendran"
  displayToolbar = false;
  isVaidUserObjToken = '';
  queryParamsUserObj: any = {};
  ptsQueryParams: object = {};
  showSBDTab: any
  showSBDAdminTab: any
  selectedreg: any
  userid: string = ""
  public vindetail: any = []
  public regdetail: any = []
  public tokenDetails: any
  public selectedRegistration: any = []
  public languageCode = ['bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'fr', 'hr', 'hu', 'it', 'lt', 'lv', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'sk', 'sl', 'sr', 'sv', 'tr', 'uk'];
  public languagepresent: boolean = false
  showNavbar = false;
  public serviceNameList: any = [];
  isshowLoader: boolean = true;
  fdrsOutOfDate: boolean = false;
  fdrsMinimumVersion: string = '';
  showDTCInfoPopUp: boolean = false;
  showMore = false;
  diagnosticHWReq = '';
  language: string = '';
  fdrsConnectionError: string = '';
  vindetails:any;
  edmMarkets: any = ['AL', 'AM', 'AZ', 'BA', 'BY', 'BG', 'HR', 'CY', 'EE', 'FK', 'GI', 'GE', 'GS', 'KZ', 'LV', 'LT', 'MT', 'MD', 'MK', 'CS', , 'UA', 'TR', 'SI', 'SK', 'CS']
  ngOnInit(): void {
    this.routeUnAuthorizedViewWhenTokenExpires();
    this.service.showMoreDiagnosticHWReqText.subscribe((data) => {
      this.showMore = data;
    })
    this.spinnerService.show();
    if (window.location.pathname === '/viewVehicleSessions' ||
      window.location.pathname === '/linkDetails' ||
      window.location.pathname === '/vehicleHelp' ||
      window.location.pathname === '/DTCDataView' ||
      window.location.pathname == '/viewDataCollectorInfo') {
      this.showNavbar = true;
      this.service.isShowFDRSLoader.next(false)
      document.getElementById('LoadingSpinner')?.remove();
    }
    localStorage.setItem('isVehileModelMissing', 'false');

    this.service.fdrsConnectionIndicator.subscribe((data) => {
      this.CanShowFDRSIcon = data == 'show' ? true : false;
    })

    this.service.isShowFDRSLoader.subscribe((data) => {
      this.isshowLoader = data;
    })

    this.service.fdrsErorCode.subscribe((data)=> {
      this.fdrsConnectionError = data;
      this.modalService.open(this.FDRSConnectionErrorPopup, { size: 'md' });
      console.log("^^^^^^^^FDRS Error Code^^^^^^^^^^^^^^^:", data);
    })

    this.service.isShowFDRSVersionInCompatableMsg.subscribe((data: any) => {
      if (data.showPopup) {
        this.fdrsOutOfDate = true;
        this.fdrsMinimumVersion = data.minimumVersion;
        this.calldialog();
      }
    })

    this.activateRoute.queryParams.subscribe(ptsQueryParams => {
      const token = ptsQueryParams['fdspToken'];

      if (token && token !== 'undefined') {
        this.createUserObj(ptsQueryParams);
      }
    });

    localStorage.setItem('DCSessionId', ''); // Data Collector session id value should be empty while launching SBDO.
  }

  routeUnAuthorizedViewWhenTokenExpires() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.url;
        console.log('current URL----------------', currentUrl);
        if (currentUrl == '/unauthorizedAccess') {
          this.showUnauthorizedAccessPage = true;
        }
      }
    });
  }

  onShow() {
    this.showMore = !this.showMore;
    this.service.showMoreDiagnosticHWReqText.next(this.showMore);
  }

  calldialog() {
    this.modalService.open(this.FDRSVersionPopup);
  }

  validatingUserObjToken(token: any) {
    console.log('---------PTS TOKEN---------', token,)
    const decodedToken: any = jwt_decode(token);
    var userType = decodedToken['userType'];
    const username = decodedToken['jti'];
    console.log(userType, username, 'token users');
    this.service.tokenValidationWithToken(username, userType, token).subscribe(tokenResponse => {
      console.log("tokenresponse is ", tokenResponse)
      this.service.rapToken.next(token);
      this.decodeUserObjToken(token);
    }, (error) => {
      console.log(error.error.response, "Error message for validating token")
      this.isVaidUserObjToken = 'false';
      this.spinnerService.hide();
      document.getElementById('LoadingSpinner')?.remove();
    });
  }

  scheduleNotification(expiryTime: number) {
    const currentTime = new Date().getTime();
    const timeUntilExpiry = expiryTime - currentTime;
    const notificationTime = timeUntilExpiry - 10 * 60 * 1000; // 10 minutes before expiry

    if (notificationTime > 0) {
      this.showExpiryNotification = true;
      setTimeout(() => {
        this.notificationService.addNotification('Your Current session is due to expire in ');
      }, notificationTime);
    }
  }

  getRegdetails() {
    const vin = {
      "vin": this.tokenDetails.vin,
      "paCode": this.tokenDetails.dealerCode,
      "country": this.tokenDetails.country,
      "language": this.tokenDetails.language
    }
  }
  vindetailsApi() {
    const vin = {
      "vin": this.tokenDetails.vin,
      "paCode": this.tokenDetails.dealerCode,
      "country": this.tokenDetails.country,
      "language": this.tokenDetails.language
    }
  }
  createUserObj(queryParams: any) {
    this.email = queryParams['Email'];
    this.marketcountry = queryParams['Market'];
    this.companyname = queryParams['CompanyName'];
    this.vin = queryParams['Vin'];
    localStorage.setItem('vin', this.vin)
    this.firstname = queryParams['FirstName'];
    this.lastname = queryParams['LastName'];
    this.language = (queryParams['language'] != undefined) ? queryParams['language'] : '';
    const queryParamsObj = {
      'email': this.email,
      'marketCountry': this.marketcountry,
      'companyName': this.companyname,
      'vin': this.vin,
      'firstName': this.firstname,
      'lastName': this.lastname
    };

    this.queryParamsUserObj = queryParamsObj;
    if (queryParams['fdspToken']) {
      const token = queryParams['fdspToken'];
      this.validatingUserObjToken(token);
    }
  }
  countryObj: any
  decodeUserObjToken(userObjtoken: any) {
    const token = userObjtoken;
    localStorage.setItem("token", token)
    const decodedToken: any = jwt_decode(token);
    let exp: any = decodedToken['exp'] * 1000;
    console.log("EXPIRY TIME*****************", exp);
    this.scheduleNotification(exp);
    var dealerCode = decodedToken['dealercode'];
    var userType = decodedToken['userType'];
    var country = decodedToken['countryCode'];
    const username = decodedToken['jti'];
    this.service.userName.next(username);
    localStorage.setItem("userName", username);
    if (userType == 'FORD_INTERNAL') {
      dealerCode = this.queryParamsUserObj['marketCountry'] + '4FORD';
      country = this.queryParamsUserObj['marketCountry'];
    }

    if (userType == 'DEALER') {
      userType = 'PTS_DEALER';
    }
    if ((userType == 'AFTERMARKET') && decodedToken['dealercode'].includes('MTR12')) {
      userType = 'PTS_AFTERMARKET';
      dealerCode = 'PTSMTR12';
      country = this.queryParamsUserObj['marketCountry'];
    }
    this.service.userType.next(userType);
    localStorage.setItem("userType", userType);

    var language = (this.language != '') ? this.language : decodedToken['languageCode'];

    this.service.getCountryDetailsWithToken(username, userType).subscribe((data) => {
      let c = data
      this.countryObj = c.filter((data: any) => {
        return data.id3 == country
      })
      const tokenParamsObj = {
        "country": this.countryObj[0].id2,
        "email": this.email,
        "language": language,
        "marketCountry": this.marketcountry,
        "userType": userType,
        "username": decodedToken['jti'],
        "dealerCode": dealerCode,
        "companyName": this.companyname,
        "vin": this.vin,
        "countryThree": this.countryObj[0].id3
      }
      console.log(tokenParamsObj, "tokenparam")
      this.service.tokenObj.subscribe((data) => {
        this.tokenDetails = data
        this.vindetailsApi();
        this.getRegdetails();
      })
      this.service.tokenVinNum.next(this.vin)
      const concatObj = { ...tokenParamsObj, ...this.queryParamsUserObj };
      this.service.setQueryParams(concatObj);
      this.requestUserRoles(concatObj);
      this.switchLang(language);
      this.service.getServiceList().subscribe(data => {
        this.serviceNameList = data;
        this.service.serviceNameListservice.next(this.serviceNameList)
      })
    })
    this.saveVinDetails(this.vin,this.marketcountry,dealerCode,language);
    this.getTempDealerCodeDetails(dealerCode,username);
  }

  requestUserRoles(userObj: any) {
    console.log(userObj.username, userObj.userType, 'Roles');
    this.service.requestUserRolesWithToken(userObj.username, userObj.userType, userObj).subscribe(userRoles => {
      console.log("userRoles", userRoles)
      localStorage.setItem('userId',userRoles.userid)
      this.userid = userRoles.id;
      this.service.loginUserId.next(userRoles.id);
      this.SBDAccessGranted = true;
      this.ParseUserObjResponse(userRoles);
      this.createSessionId(this.userid, userObj);
    }, (error) => {
      this.SBDAccessGranted = false;
    });
  }
  saveVinDetails( vin:String,market:String, dealercode:String, language:String) {
    const vinReq = {
      vin: vin,
      paCode: dealercode,
      country: market,
      language: language
    };
    console.log("vinReg", vinReq);
    this.service.getVindetails(vinReq).subscribe(((data) => {
      this.vindetails = data;
      this.service.setVinDetails(this.vindetails);
    }))
  }
  createSessionId(userId: string, userObj: any) {
    const req = {
      "userId": userId,
      "sessionSource": "gfdrs",
      "vin": this.vin
    }
    this.service.createSession(req).subscribe((data: any) => {
      localStorage.setItem("newSessionID", data)
      localStorage.setItem("sessionID", data)
      this.setSystemShapShotDetails(data);
      this.service.fromResume.next(false);
      this.service.fromCapture.next(false)
      this.service.navigateSymptom.next('')
      localStorage.setItem('isVehileModelMissing', 'false');
      //Network
      console.log('Passing USER ID---------------->', this.userid);
      this.service.tokenObj.next(userObj)
      this.service.userId.next(this.userid)
      this.fdrsClientService.initFdrsClient("startup");
      this.service.isSessionCreated.next(false);
      this.spinnerService.hide();
      document.getElementById('LoadingSpinner')?.remove();
      this.isVaidUserObjToken = 'true';
    }, (error) => {
      if (error.status == 404) {
        this.service.userId.next(this.userid)
        this.isshowLoader = false;
        localStorage.setItem('isVehileModelMissing', 'true');
        this.service.tokenObj.next(userObj)
        this.modalService.open(this.VehicleModelMissing, { size: 'md' });
        document.getElementById('LoadingSpinner')?.remove();
        console.log("--------Create Session Error------------", error);
        const vinDetails = this.service.getVinDetailsSnapshot(); // null-safe
        let reportdto={
          "vin": this.tokenDetails.vin,
          "id": "1002",
          "vehicleType":vinDetails?.vehicleLineDescription,
          "market": this.tokenDetails.marketCountry,
          "dealerCode":this.tokenDetails.dealerCode,
          "gnumber":"not applicable"
        }
        this.service.reportdetails(reportdto).subscribe((data)=>{});

      }
    })
  }

  // Set FDRS version as unknown intially. when FDRS is connected update the details
  setSystemShapShotDetails(sessionId: any) {
    let req = {
      "sessionid": sessionId,
      "fdrsVersion": "unknown",
      "javaVersion": "unknown",
      "firmwareVersioninVCM": "unknown",
      "firmwareVersioninVMM": "unknown",
      "osversion": "unknown",
      "memoryinfo": "unknown",
      "osname": "unknown",
      "cpuinfo": "unknown",
      "deviceserialnumber": "unknown"
    }
    localStorage.setItem("systemSnapshot", JSON.stringify(req));
    this.service.setSystemSnapShotDetails(req).subscribe((data) => {
      console.log('----updated system snapshot with value unknown-------', data);
    })
  }

  openGtacLink(content: any) {
    if (!this.edmMarkets.includes(this.tokenDetails['country'])) {
      const newWindow = window.open(this.service.gtacUrl + 'LANG=' + this.tokenDetails.language + '-US&Contactid=&vin=' + this.tokenDetails.vin + '&USERID=' + this.tokenDetails.username + '&Symptom_codes=12&GEO=' + this.tokenDetails.countryThree + '&PACODE=' + this.tokenDetails.dealerCode + '&countryCode=' + this.tokenDetails.countryThree + '&Model=' + null + '&Year=' + null, '_blank', 'width=700,height=700');
    }
    else {
      this.modalService.open(content, {
        centered: true,
        backdrop: 'static', size: 'md'
      });
    }
  }
  switchLang(lang: string) {
    this.translate.use(lang.toLowerCase());
    if (this.languagepresent = this.languageCode.includes(lang.toLowerCase())) {
      this.translate.use(lang.toLowerCase());
    }
    else {
      this.translate.use('en')
    }
    this.translate.get('DiagnosticHWReq').subscribe((data) => {
      this.diagnosticHWReq = data;
    });
  }

  ParseUserObjResponse(userRolesObj: any) {
    this.showHideSBDOTabs(userRolesObj.selectedUserRoles);
  }

  showHideSBDOTabs(selectedRoles: string[]) {
    if (selectedRoles.includes('QUALIFIED_VEHICLE_CONVERTER')) {
      this.SBDTab = true;
      this.router.navigateByUrl('/wltpHome/wltpVinConfigurationForm/VinConfig');
    }

    if (selectedRoles.includes('VEHICEL_SPECIFIC_DC')) {
      this.service.showDataCollectorsBtn.next(true);
    } else {
      this.service.showDataCollectorsBtn.next(false);
    }

    if(selectedRoles.includes('TEMP_DEALER')) {
      this.service.showTempDealerBtn.next(true);
    } else {
      this.service.showTempDealerBtn.next(false);
    }

    if (selectedRoles.includes('FDRS_VERSION_ADMIN')) {
      this.service.enableFDRSVersionEditPermissionInAdhoc.next(true);
    }
    if (selectedRoles.includes('SYSTEM_ADMINISTRATOR') || selectedRoles.includes('IT_SYSTEM_ADMINISTRATOR')) {
      this.showSBDAdminTab = true;
      this.service.showSBDAdminTab.next(this.showSBDAdminTab);
      if (selectedRoles.includes('SYSTEM_ADMINISTRATOR')) {
        this.service.showAdminTab.next(true);
      } else {
        this.service.showAdminTab.next(false);
      }
    }
    else {
      this.showSBDAdminTab = false;
      this.service.showSBDAdminTab.next(this.showSBDAdminTab);
    }

    if (this.showSBDAdminTab || this.showSBDTab) {
      this.SBDAccessGranted = true;
    } else {
      this.SBDAccessGranted = false;
    }
  }
  getTempDealerCodeDetails(dealerCode: string,username: string) {
    let req = {
        "userName": username,
        "dealerCode": dealerCode,
        "accountStatus":"Active"
    }
    this.service.requestTempDealerCode(req).subscribe((data)=> {
      if(data.length != 0) {
         this.service.tempDealerCode.next(data[0].tempdealercode);
      } else {
        this.service.tempDealerCode.next('null');
      }
    })
  }
}
